import { ISmartrrBundleConfig } from "@smartrr/shared/entities/SellingPlanGroup";
import { IShopifyCollection } from "@smartrr/shared/utils/bundles";

import { CustomerSubReducer } from "@customer-app/state/typedCustomerRedux";

export interface IBundleReducerState {
  isLoading: boolean;
  bundle: ISmartrrBundleConfig[];
  hasLoadedBundleCollection: boolean;
  bundleCollections: IShopifyCollection[];
}

const initialState: IBundleReducerState = {
  isLoading: false,
  bundle: [],
  hasLoadedBundleCollection: false,
  bundleCollections: [],
};

export const bundleReducer: CustomerSubReducer<IBundleReducerState> = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING_BUNDLES": {
      return {
        ...initialState,
        isLoading: true,
      };
    }

    case "ERROR_LOADING_BUNDLES": {
      return {
        ...state,
        isLoading: false,
      };
    }

    case "LOADED_BUNDLES": {
      return {
        ...state,
        isLoading: false,
        bundle: [...action.payload.bundles],
      };
    }

    case "LOADING_BUNDLE_COLLECTIONS": {
      return {
        ...state,
        hasLoadedBundleCollection: true,
      };
    }

    case "LOADED_BUNDLE_COLLECTION": {
      return {
        ...state,
        bundleCollections: [
          ...state.bundleCollections,
          {
            ...action.payload.collection,
            handle: action.payload.handle,
          },
        ],
      };
    }

    case "LOADED_BUNDLE_COLLECTIONS": {
      return {
        ...state,
        bundleCollections: action.payload.collections,
      };
    }

    default: {
      return state;
    }
  }
};
